export default __webpack_public_path__ + "eac1b23990a6da3472d302401f83e155.woff";